import { memberApi } from '../config/axios-config';

export const updateDemographicsAddress = (newAddress,  tenantInfo)=> {
    memberApi.post('/v2/my/updateDemographic', {newAddress} ,  {
        headers: { 'tenant-id':tenantInfo  }
    });
};